export const Hr = () => <hr className="bg-strokes border-strokes" />;
